import axios from "axios";

const state = {
  booking: {},
  booking_original: {},
  dialogCheckout: false
}

const getters = {
  getBooking: state => {
    return state.booking
  },
  getBookingOriginal: state => {
    return state.booking_original
  },
  getDialogCheckout: (state) =>{
    return state.dialogCheckout
  },
}

const actions = {
  setDialogCheckout: async (context,value) => {
    context.commit('SET_DIALOG_CHECKOUT', value)
  },
  setBooking: async (context,value) => {
    context.commit('SET_BOOKING', value)
  },
  setBookingOriginal: async (context,value) => {
    context.commit('SET_BOOKING_ORIGINAL', value)
  },
  submitBooking : async (context,payload) => {

    let url = `api/v1/bookings/store/`;

    return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, payload,{
        'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`}
      },

    ).then(result => {

      return {
        success: true,
        result: result.data
      }

    }).catch(error => {

        return {
          success: false,
          message: error.response.data
        }

    });

  },
  submitPromoCode : async (context,payload) => {

    let url = `api/v1/bookings/apply-promo-code/`;

    return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, payload,{
        'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`}
      },

    ).then(result => {

      if(result.data.result == 'not_found'){

        return {
          success: false,
          result: 'not_found'
        }

      }else {

        return {
          success: true,
          result: result.data
        }

      }

    }).catch(error => {

      return {
        success: false,
        message: error.response.data
      }

    });

  },

  rollback : async (context,payload) => {

    let url = `api/v1/bookings/cancel`;

    return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, payload,{
        'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`}
      },
    ).then(result => {

      return {success: true}

    }).catch(error => {

      return {
        success: false,
        message: error.response.data
      }

    });

  },

  confirm : async (context,payload) => {

    let url = `api/v1/bookings/success`;

    return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, payload,{
        'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`}
      },
    ).then(result => {

      return {success: true}

    }).catch(error => {

      return {
        success: false,
        message: error.response.data
      }

    });

  },


  cancel : async (context,payload) => {

    let url = `api/v1/cancellations/make-request/`;

    return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`,payload,{
        'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
        "Content-Type": "application/json"
      },
    ).then(result => {

      return {
        success: result.data,
      }

    }).catch(error => {

      return {
        success: false,
        message: error.response.data
      }

    });

  },

}

const mutations = {
  SET_BOOKING: (state, value) => {
    state.booking = value
  },
  SET_BOOKING_ORIGINAL: (state, value) => {
    state.booking_original = value
  },
  SET_DIALOG_CHECKOUT(state, value) {
    state.dialogCheckout = value
  },
}


export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
